import React, { useEffect } from 'react'

export default function Download() {
  useEffect(() => {
    window.location.href = 'https://play.google.com/store/apps/details?id=com.justinolab.granna'
  }, []);
  return <div />
}